import React from "react";
import './SocialFollow.css';
import ig from "./../../assets/icons/instagram.png"
import tw from "./../../assets/icons/twitter.png"
import igb from "./../../assets/icons/instagram-black.png"
import twb from "./../../assets/icons/twitter-black.png"

export const SocialFollowWhite = () => {
  return (
    <div className="social-container">
      <a className='social-icon' href="https://www.instagram.com"><img src={ig} alt="instagram" width={20}
                                                                       height={'auto'}/></a>
      <a className='social-icon' href="https://www.twitter.com"><img src={tw} alt="twitter" width={20} height={'auto'}/></a>
    </div>
  );
};

export const SocialFollowBlack = () => {
  return (
    <div className="social-container" style={{justifyContent: "center"}}>
      <a className='social-icon' href="https://www.instagram.com"><img src={igb} alt="instagram" width={20}
                                                                       height={'auto'}/></a>
      <a className='social-icon' href="https://www.twitter<.com"><img src={twb} alt="twitter" width={20}
                                                                      height={'auto'}/></a>
    </div>
  );
};